/* Touch screens (no hover): drop :hover styles so a tapped button does not stay in its hover look.
   Desktop keeps hover. Only this site's own stylesheets are touched. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
  function strip(rules) {
    for (var i = rules.length - 1; i >= 0; i--) {
      var r = rules[i];
      if (r.cssRules && !r.selectorText) { strip(r.cssRules); continue; }
      if (!r.selectorText || r.selectorText.indexOf(':hover') === -1) continue;
      var keep = r.selectorText.split(',').filter(function (s) { return s.indexOf(':hover') === -1; });
      if (keep.length) { try { r.selectorText = keep.join(','); } catch (e) {} }
      else { try { (r.parentRule || r.parentStyleSheet).deleteRule(i); } catch (e) {} }
    }
  }
  function run() {
    for (var i = 0; i < document.styleSheets.length; i++) {
      var s = document.styleSheets[i];
      if (s.href && s.href.indexOf(location.origin) !== 0) continue;
      try { if (!s.__wbaTouch) { strip(s.cssRules); s.__wbaTouch = true; } } catch (e) {}
    }
  }
  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
})();
